export default function Hero() {
  return (
    <div className="relative min-h-screen flex items-center overflow-hidden bg-white pt-20">
      {/* Background with subtle texture */}
      <div className="absolute inset-0 bg-white">
        <div className="absolute inset-0 opacity-[0.02] bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0iZ3JpZCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48cGF0aCBkPSJNIDQwIDAgTCAwIDAgMCA0MCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')]"></div>
      </div>

      <div className="max-w-[1400px] mx-auto px-8 w-full relative z-10">
        <div className="flex items-center justify-between">
          {/* Left side - Main headline */}
          <div className="w-[60%] pl-[5%]">
            <h1 className="font-bold leading-[0.9] mb-8" style={{ fontSize: '120px', fontFamily: 'Georgia, serif' }}>
              MODERN
              <br />
              iOS
              <br />
              APPLICATIONS
            </h1>
            <p className="text-lg font-light opacity-40 max-w-[500px] pl-2">
              Enhancing security and experience on mobile devices
            </p>
          </div>

          {/* Right side - Gradient sphere with phone mockup */}
          <div className="w-[40%] relative flex items-center justify-center">
            <div className="relative w-[500px] h-[500px]">
              {/* Gradient sphere */}
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-teal-400 via-teal-500 to-emerald-600 opacity-20 blur-3xl"></div>
              
              {/* iPhone mockup */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-[15deg]">
                <div className="w-[280px] h-[560px] bg-gradient-to-br from-gray-900 to-gray-800 rounded-[50px] shadow-2xl p-3 border-8 border-gray-900">
                  <div className="w-full h-full bg-white rounded-[42px] overflow-hidden relative">
                    {/* Notch */}
                    <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[120px] h-[28px] bg-gray-900 rounded-b-3xl z-10"></div>
                    
                    {/* App screen mockup */}
                    <div className="w-full h-full bg-gradient-to-br from-teal-50 to-emerald-50 flex flex-col items-center justify-center p-8">
                      <div className="w-24 h-24 bg-gradient-to-br from-teal-500 to-emerald-600 rounded-3xl flex items-center justify-center mb-6 shadow-lg">
                        <i className="ri-shield-check-line text-5xl text-white"></i>
                      </div>
                      <div className="text-center">
                        <div className="text-2xl font-bold text-gray-900 mb-2">VPN</div>
                        <div className="text-sm text-gray-600">Secure Connection</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
